import React from 'react';
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useToastContext } from '../context/ToastContext';
import './ToastContainer.css';

const ICONS = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
};

function ToastContainer() {
  const { toasts, removeToast } = useToastContext();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="false" role="status">
      {toasts.map((toast) => {
        const Icon = ICONS[toast.type] || Info;
        return (
          <div key={toast.id} className={`toast toast-${toast.type}`} role={toast.type === 'error' ? 'alert' : 'status'}>
            <div className="toast-icon" aria-hidden="true">
              <Icon size={18} />
            </div>
            <div className="toast-message">{toast.message}</div>
            {toast.action && (
              <button
                type="button"
                className="toast-action"
                onClick={() => {
                  removeToast(toast.id);
                  toast.action.onClick();
                }}
              >
                {toast.action.label}
              </button>
            )}
            <button
              className="toast-dismiss"
              onClick={() => removeToast(toast.id)}
              aria-label="Dismiss notification"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default ToastContainer;
